export default __webpack_public_path__ + "static/media/step1-min.f85ba340.webp";